import React, { memo } from 'react';
import { Page } from '@web/components';

import { PageBody } from './PageBody';
import { TITLE, PREFIX, CHURCH, PLACE } from 'config/custom';


export const WebPage: React.FC = memo(() =>
	<Page title={TITLE} description={`${PREFIX} ${CHURCH} ${PLACE}`}>
		<PageBody/>
	</Page>
);
